export const translationEngDefault = {
  SkhemataFaqList: {
    "showMoreButton": "Show More...",
  }
};